export default __webpack_public_path__ + "assets/audios/b2f265096a765bcb740c2ab5679f09f8.mp3";